<template>
  <div class="video-block">
    <div class="video-block__modal" v-if="modalVideoData">
      <ModalVideo :data="modalVideoData" @hideModal="hideModal"/>
    </div>
    <div class="video-block__top" data-aos="fade" data-aos-delay="150">
      <h3 class="video-block__title" v-if="title">
        {{ title }}
      </h3>

      <div class="video-block__arrows" v-if="items">
        <div class="video-block__arrow video-block__arrow--prev">
          <ButtonRound
              :data="arrowLeft"
              @click="slideChange('prev')"
          />
        </div>
        <div class="video-block__arrow video-block__arrow--next">
          <ButtonRound
              :data="arrowRight"
              @click="slideChange('next')"
          />
        </div>
      </div>
    </div>

    <div class="video-block__slider" v-if="items" data-aos="fade" data-aos-delay="200">
      <div class="swiper-container">
        <Swiper
            v-bind="swiperOptions"
            @swiper="onSwiper"
            @slideChange="swiperSlideChange">
          <SwiperSlide v-for="(item, idx) in items" :key="idx">
            <div class="video-block__slide">
              <CardVideo :data="item" @click="cardClick(item.link, item.video)"/>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <a :href="link.href" class="video-block__link" target="_blank" rel="nofollow" v-if="link"
       data-aos="fade" data-aos-delay="200">
     <span class="video-block__link-text">
        {{ link.text }}
     </span>

      <Icon name="24/external"/>
    </a>
  </div>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import CardVideo from '@/components/CardVideo/CardVideo.vue';
import ButtonRound from '@/components/ButtonRound/ButtonRound.vue';
import Icon from '@/components/Icon/Icon.vue';
import ModalVideo from '@/components/ModalVideo/ModalVideo.vue';
import { enableScroll, disableScroll } from '@/assets/js/scroll';

export default {
  name: 'VideoBlock',
  components: {
    ModalVideo,
    Icon,
    ButtonRound,
    CardVideo,
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  setup() {
    // eslint-disable-next-line no-unused-vars
    const swiperRef = ref(null);
    const swiperOptions = ref({
      slidesPerView: 2,
      spaceBetween: 0,
      speed: 800,
      a11y: false,
      loop: true,
      preventInteractionOnTransition: true,
    });

    return {
      swiperOptions,
    };
  },
  data() {
    return {
      realIndex: 0,
      currentVideoSrc: null,
      currentVideoFile: null,
    };
  },
  computed: {
    title() {
      return this.data.title;
    },
    items() {
      const { items } = this.data;

      return items && items.length ? items : null;
    },
    link() {
      return this.data.link;
    },
    video() {
      return this.data.video;
    },
    arrowLeft() {
      return {
        icon: '24/chevron-left',
      };
    },
    arrowRight() {
      return {
        icon: '24/chevron-right',
      };
    },
    modalVideoData() {
      if (!this.currentVideoSrc && !this.currentVideoFile) return null;

      return {
        file: this.currentVideoFile,
        src: this.currentVideoSrc,
      };
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiperRef = swiper;

      this.realIndex = swiper.realIndex;
    },
    slideChange(direction) {
      if (direction === 'prev') {
        this.swiperRef.slidePrev();
      }

      if (direction === 'next') {
        this.swiperRef.slideNext();
      }
    },
    swiperSlideChange(swiper) {
      this.realIndex = swiper.realIndex;
    },
    cardClick(link, video) {
      if (!link && !video) return;
      if (link) this.currentVideoSrc = link;
      if (video) this.currentVideoFile = video;
    },
    hideModal() {
      this.currentVideoSrc = null;
      this.currentVideoFile = null;
    },
  },
  watch: {
    modalVideoData(data) {
      if (data) {
        disableScroll();
      } else {
        enableScroll();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VideoBlock";
</style>
